module.exports = __webpack_public_path__ + "static/img/1.3e7ae6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/lynn/1.png
// module id = 9zvB
// module chunks = 1